module.exports = __webpack_public_path__ + "static/img/webHispanos.a6cfd3a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/portfolioWeb/webHispanos.webp
// module id = 481
// module chunks = 1